import { FC, PropsWithChildren } from 'react';
import { Navigate } from 'react-router-dom';
import { useDataImportAccess } from '../../atlas/hooks/use-data-import-access';
import { Loading } from './style';

export const DataImportAccessGuard: FC<PropsWithChildren<unknown>> = ({ children }) => {
  const { isAllowed, isLoading } = useDataImportAccess();

  if (isLoading) {
    return <Loading />;
  }

  if (!isAllowed) {
    return <Navigate replace to="/" />;
  }

  return <>{children}</>;
};
